import { useState, useEffect, useCallback } from 'react';
import axios from 'axios'; // Assuming you use Axios for API calls

const useApiGetPost = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (method, url, payload = null, config = {}) => {
    setLoading(true);
    setError(null);
    try {
      let response;
      if (method === 'GET') {
        response = await axios.get(url, config);
      } else if (method === 'POST') {
        response = await axios.post(url, payload, config);
      } else {
        throw new Error('Unsupported HTTP method');
      }
      setData(response.data);

      return response
    } catch (err) {
      console.log("err>>>", err)
      setError(err);
      return null
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array ensures fetchData is stable

  const get = useCallback((url, config = {}) => {
    return fetchData('GET', url, null, config);
  }, [fetchData]);

  const post = useCallback((url, payload, config = {}) => {

    console.log("url-> post ", url , "payload->", payload,)
    return fetchData('POST', url, payload, config);
  }, [fetchData]);

  return { data, loading, error, get, post };
};

export default useApiGetPost;